$(function(){
	var winW = $(window).width(), 
		winH = $(window).height();
	function anchorLink(){
		$('a[href^="#"]').click(function(){
			var headerH = winW < 960 ? 55 : $(".header").outerHeight(true);
			var speed = 1000;
			var href= $(this).attr("href");
			var target = $(href == "#" || href == "" ? 'html' : href);
			var position = target.offset().top - headerH;
			$("html, body").animate({scrollTop:position}, speed, "swing");
			return false;
		});
	}
	anchorLink();
});